$(function () {
    $('.amas-logo button.download-document, .amas-flyer button.download-document').click(function (e) {
        e.preventDefault();
        let url = "";

        //has radio options
        var checkedRadio = $(this).closest(".amas-logo").find("input[type=radio]:checked");
        if (checkedRadio.length > 0) {
            console.log("sale del radio");
            url = $(checkedRadio[0]).data("url");
        }
        else { //has "data-url"? 
            url = $(this).data("url");
        }

        if (!url.toLowerCase().startsWith("http://") && !url.toLowerCase().startsWith("https://")) {
            url = "//" + url;
        }

        window.location.href = url;
    });
});